import { submitV2AnalyticsEvent } from "../../../analytics/analyticsUtils";
import { fetchUserDetails } from "../../utils/getUserDetails";
import statusMap from "../StockAvailability/StockAvailabilityStatusMap";

export const getSelectedBranchFromLocalStorage = (userDetails) => {
  const selectedBranchLocalStorageKey = `selectedBranch_${
    userDetails ? userDetails.id : undefined
  }`;
  const rawSelectedBranchLocalStorage = localStorage.getItem(
    selectedBranchLocalStorageKey
  );
  const parsedSelectedBranchLocalStorage =
    selectedBranchLocalStorageKey && JSON.parse(rawSelectedBranchLocalStorage);

  return parsedSelectedBranchLocalStorage;
};

export const setSelectedBranchToLocalStorage = async (newSelectedBranch) => {
  const userDetails = await fetchUserDetails();
  const selectedBranchLocalStorageKey = `selectedBranch_${
    userDetails ? userDetails.id : undefined
  }`;
  localStorage.setItem(selectedBranchLocalStorageKey, newSelectedBranch);
};

export const getBranchId = async () => {
  const userDetails = await fetchUserDetails();
  const homeBranchNumber =
    userDetails && userDetails.HomeBranch
      ? userDetails.HomeBranch.branchNumber
      : null;
  const selectedBranch = getSelectedBranchFromLocalStorage(userDetails);

  if (selectedBranch) {
    return selectedBranch.storeCode;
  } else if (homeBranchNumber) {
    return homeBranchNumber;
  } else {
    return null;
  }
};

export const getBranchName = async () => {
  const userDetails = await fetchUserDetails();
  const homeBranch =
    userDetails && userDetails.HomeBranch ? userDetails.HomeBranch.name : null;
  const selectedBranch = getSelectedBranchFromLocalStorage(userDetails);

  if (selectedBranch) {
    return selectedBranch.storeName;
  } else if (homeBranch) {
    return `${homeBranch}`;
  } else {
    return null;
  }
};

export const enableBranchSelectorWidget = (
  productCode,
  qty,
  uom,
  selectedBranchId
) => {
  const storeFinderWidget = document.querySelector(
    "rg-max-store-finder-widget"
  );
  if (!storeFinderWidget) {
    return;
  }
  storeFinderWidget.setAttribute("product-code", productCode);
  storeFinderWidget.setAttribute("quantity", qty);
  storeFinderWidget.setAttribute("unit-of-measure", uom);
  if (selectedBranchId) {
    storeFinderWidget.setAttribute("selected-branch-id", selectedBranchId);
  }
  storeFinderWidget.setAttribute("mode", "PDP");
  storeFinderWidget.setAttribute("show", "true");

  submitV2AnalyticsEvent("viewBranchForStockInformation", {
    originID: null,
    origin: "PDP",
  });
};

export const onBranchSearch = (event) => {
  submitV2AnalyticsEvent("searchBranchForStockInformation", {
    originID: null,
    origin: "PDP",
    searchMethod: event.detail.searchMethod,
  });
};

export const onBranchSelect = (event, updateSelectedBranch) => {
  const storeFinderWidget = document.querySelector(
    "rg-max-store-finder-widget"
  );

  setSelectedBranchToLocalStorage(JSON.stringify(event.detail));
  if (storeFinderWidget) {
    storeFinderWidget.setAttribute("show", "false");
  }
  updateSelectedBranch({
    branchId: event.detail.storeCode,
    branchName: event.detail.storeName,
  });

  submitV2AnalyticsEvent("selectBranchForStockInformation", {
    originID: null,
    origin: "PDP",
    stockAvailability: statusMap[event.detail.stockAvailability].eventText,
    distance: event.detail.distance,
    branchName: event.detail.storeName,
    branchID: event.detail.storeCode,
  });
};
